import { SearchResultData } from "../../app/slices/SearchResultsSlice";
import { InteractionFactoryEntity } from "../../features/interaction_factory/InteractionFactory";
import EnableDefaultCameraNodePreview from "../../features/sequence/node_previews/EnableDefaultCameraNodePreview";
import { GetNewGuid } from "../../helpers/GuidHelper";
import { Actor } from "../Actor";
import Take from "../Take";
import Interaction, { InteractionType } from "./Interaction";
import {
  compactSearchableStrings,
  getBooleanSearchLabels,
} from "./SearchableInteractionValues";

export interface IEnableDefaultCamera extends Interaction {
  Instant: boolean;
}

export const enableDefaultCameraInteraction = (): InteractionFactoryEntity => {
  const view = <></>;

  const create = (
    getKeys: (amount: number) => string[]
  ): IEnableDefaultCamera => {
    return {
      id: GetNewGuid(),
      name: "Enable Default Camera",
      type: InteractionType.EnableDefaultCamera,
      Instant: false,
    };
  };

  const migrate = (
    from: number,
    to: number,
    interaction: Interaction
  ): IEnableDefaultCamera => {
    return interaction as IEnableDefaultCamera;
  };

  const copy = (
    interaction: Interaction,
    getKeys: (amount: number) => string[]
  ): IEnableDefaultCamera => {
    return {
      ...(interaction as IEnableDefaultCamera),
      id: GetNewGuid(),
    };
  };

  const validate = (
    interaction: Interaction,
    getValue: (key: string) => string
  ): string[] => {
    return [];
  };

  const filter = (
    interaction: Interaction,
    takeName: string,
    getMatchingResults: (
      searchableStrings: string[],
      takeName: string,
      interaction: Interaction,
      filterType: string
    ) => SearchResultData[]
  ): SearchResultData[] => {
    const converted = interaction as IEnableDefaultCamera;
    return getMatchingResults(
      compactSearchableStrings(
        interaction.name,
        getBooleanSearchLabels(
          converted.Instant,
          "Instant",
          "Not Instant",
        ),
      ),
      takeName,
      interaction,
      "Enable Default Camera"
    );
  };

  const validateErrors = (
    interaction: Interaction,
    parentTake: Take,
    currentTake: Take,
    actorPresets: Actor[]
  ): string[] => {
    return [];
  };

  return {
    View: view,
    NodeView: (nodeId: string, interaction: Interaction) => (
      <EnableDefaultCameraNodePreview
        nodeId={nodeId}
        interaction={interaction}
      />
    ),
    FilterType: "Enable Default Camera",
    Create: create,
    Migrate: migrate,
    Copy: copy,
    Validate: validate,
    Filter: filter,
    ValidateErrors: validateErrors,
  };
};
